// `public/more/`'s error `code` field, as of this task, still comes back as
// the internal `EducationError` codes (`REQUEST_REJECTED`, `EDITION_LIMIT_REACHED`
// — see `apps.project_education.services.generation.request_more` /
// `errors.py`) rather than the public contract's own `"rejected"` / `"limit"`
// (task-12-brief.md's table). The backend is being fixed to send the public
// spelling; until then — and afterwards, since a stale build could still
// answer the old way for a moment — this is the one place that has to know
// both spellings exist. Every caller reads through `classifyMoreOutcome`
// instead of comparing `code` directly.
export type PublicMoreOutcome = "rejected" | "limit" | "unavailable"

const REJECTED_CODES = new Set(["rejected", "REQUEST_REJECTED"])
const LIMIT_CODES = new Set(["limit", "EDITION_LIMIT_REACHED"])
const UNAVAILABLE_CODES = new Set(["unavailable"])

/**
 * Reads the `code` first (either spelling), and falls back to the HTTP
 * status — which has matched the brief's table on both the old and the new
 * backend all along (422/409/404) — for a response that carries no
 * recognizable code at all (a malformed body, a network-level failure).
 */
export const classifyMoreOutcome = (
  code: string | undefined,
  status: number
): PublicMoreOutcome | null => {
  if (code && REJECTED_CODES.has(code)) return "rejected"
  if (code && LIMIT_CODES.has(code)) return "limit"
  if (code && UNAVAILABLE_CODES.has(code)) return "unavailable"
  if (status === 422) return "rejected"
  if (status === 409) return "limit"
  if (status === 404) return "unavailable"
  return null
}
